var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2__modal-popup__body rounded bg-white text-center pb-12 pt-16 relative px-8"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }